import { Reveal } from '../Reveal';
import { SectionHeader } from '../SectionHeader';
import { CheckList, DemoCaption } from './shared';

// Section 6 — plans, priorities and weekly accountability.
export const CompassPlans = ({ sp }) => (
  <section aria-labelledby="compass-plans-heading" data-testid="compass-plans" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <SectionHeader
            align="left"
            eyebrow="Plans & Accountability"
            title="Turn plans into consistent weekly action"
            description={sp.plansCopy}
            testid="compass-plans-header"
          />
          <div className="mt-8">
            <CheckList items={sp.plansPoints || []} testid="compass-plans-points" />
          </div>
          <p className="mt-6 border-l-2 border-gold-500 pl-4 text-sm font-medium leading-relaxed text-slate-600">
            Compass supports the management rhythm — software alone does not guarantee accountability, but it makes ownership and follow-through visible.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="rounded-xl border border-slate-200 bg-mist p-4 sm:p-6">
            <img
              src={sp.shots.dashboard.src}
              alt={sp.shots.dashboard.alt}
              width={sp.shots.dashboard.width}
              height={sp.shots.dashboard.height}
              loading="lazy"
              className="w-full rounded-lg border border-slate-200"
            />
            {sp.shots.weekly?.src && (
              <img
                src={sp.shots.weekly.src}
                alt={sp.shots.weekly.alt}
                width={sp.shots.weekly.width}
                height={sp.shots.weekly.height}
                loading="lazy"
                className="mt-4 w-full rounded-lg border border-slate-200"
                data-testid="compass-weekly-visual"
              />
            )}
          </div>
          <DemoCaption />
        </Reveal>
      </div>
    </div>
  </section>
);
